import React from "react";

const SourceOverviewLoader = () => {
    return (
        <div className="source_overview_loader_cont">
            <div className="source_overview_loader_cont_header_row">
                <div className="source_overview_loader_cont_header_item fade-in"></div>
                <div className="source_overview_loader_cont_header_item fade-in"></div>

            </div>
            <div className="source_overview_loader_cont_header_row">
                <div className="source_overview_loader_cont_header_item fade-in"></div>
                <div className="source_overview_loader_cont_header_item fade-in"></div>
            </div>
            <div className="source_overview_loader_cont_header_title fade-in"></div>
            <div className="source_overview_loader_cont_header_body fade-in">

            </div>
        </div>
    )
}

export default SourceOverviewLoader